import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/verein/satzung')({
  component: () => (
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
      <h1 className="text-3xl font-black text-ink">Satzung</h1>
      <p className="mt-2 text-sm text-ink-muted">Die Satzung der Faninitiative Spandau e.V.</p>
    </div>
  ),
});
